export default "__VITE_ASSET__Q1qgi7za__"